exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".red-icon-up {\n  color: red; }\n\n.orange-icon-up {\n  color: darkorange; }\n\n.orange-icon-down {\n  color: orange; }\n\n.red-icon-down {\n  color: #ffdc2e; }\n\n.green-icon-up,\n.green-icon-down,\n.green-icon {\n  color: limegreen; }\n\n.blue-icon {\n  color: blue; }\n\n.grey-icon {\n  color: #777777; }\n\n.red-icon-down,\n.orange-icon-down,\n.orange-icon-up,\n.red-icon-up,\n.green-icon-up,\n.green-icon-down,\n.green-icon,\n.blue-icon,\n.grey-icon {\n  font-weight: bold; }\n\n.ellipsed-text {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap; }\n\n.buttons {\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex; }\n\n.report-button {\n  margin-right: 0.4em; }\n\n.report-button:last-child {\n  margin-right: 0.9em;\n  padding-left: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/edi/angular/app/views/oes/usage-stats/usage-stats.component.scss
// module id = ../../../../../angular/app/views/oes/usage-stats/usage-stats.component.scss
// module chunks = main